import { parseXY } from 'xy-parser';
import { Chromatogram } from "../chromatogram.js";
/**
 * Creates a new Chromatogram from text data.
 * @param text - String containing the data as CSV or TSV.
 * @param options
 */
export function fromText(text, options = {}) {
    const data = parseXY(text, options);
    const time = data.x;
    const series = {
        intensity: data.y,
    };
    return new Chromatogram(time, series);
}
//# sourceMappingURL=text.js.map